if (!customElements.get('hulk-app-table')) {
    customElements.define(
        'hulk-app-table',
        class HulkAppTable extends HTMLElement {
            constructor() {
                super();

                this.hulkCustomTable = this.querySelector('.hulkapps-volumes-custom-table');
            }

            connectedCallback() {
                const observer = new MutationObserver((mutationsList) => {
                    for (const mutation of mutationsList) {
                        if (mutation.type === 'attributes' || mutation.type === 'childList') {
                            this.hulkTable = this.querySelector('.hulkapps-table');
                            if (this.hulkTable) {
                                observer.disconnect();
                                this.initTable();
                            }
                        }
                    }
                });

                observer.observe(this, {
                    attributes: true,
                    childList: true,
                    subtree: true,
                });
            }

            initTable() {
                let firstRow = this.hulkTable.querySelectorAll('tr td:nth-child(1)');
                let secondRow = this.hulkTable.querySelectorAll('tr td:nth-child(2)');
                let table = `<div class="inner-table"><table>`;
                table += `<tr>`;
                for (let i = 0; i < firstRow.length; i++) {

                    table += `<td>${firstRow[i].textContent.replace(/[a-zA-Z\s]/g, '')}</td>`;
                }
                table += `</tr>`;
                table += `<tr>`;
                for (let i = 0; i < secondRow.length; i++) {
                    table += `<td>${secondRow[i].textContent.replace(/[a-zA-Z\s]/g, '')}</td>`;
                }
                table += `</tr>`;
                table += `</table></div>`;
                this.hulkCustomTable.innerHTML = table;
                this.hulkCustomTable.style.display = 'block';
            }

            updateTable() {
                this.initTable();
            }
        }
    );
}